import http from '@/services/http'
import { delayed } from '@/utils'

const request = null

const getInitialState = () => ({
  fetchInProgress: false,
  fetchPromise: null,
  submitInProgress: false,
  answers: [],
  application: {
    id: null,
    organization: {},
    questions: [],
    program: {
      id: null,
      name: null,
      type: null,
    },
  },
})

export default {
  namespaced: true,
  state: getInitialState(),
  mutations: {
    CLEAR(state) {
      Object.assign(state, getInitialState())
    },
    START_FETCH(state, fetchPromise) {
      state.fetchInProgress = true
      state.fetchPromise = fetchPromise
    },
    STOP_FETCH(state) {
      state.fetchInProgress = false
      state.fetchPromise = null
    },
    SET_APPLICATION_DATA(state, application) {
      state.application = application
    },
    SET_ANSWERS(state, answers) {
      state.answers = answers
    },
    START_SUBMIT(state) {
      state.submitInProgress = true
    },
    STOP_SUBMIT(state) {
      state.submitInProgress = false
    },
    START_SAVE(state) {
      state.saveInProgress = true
    },
    STOP_SAVE(state) {
      state.saveInProgress = false
    },
  },
  actions: {
    async fetch({ commit, state }, { startupId, applicationId }) {
      if (state.fetchPromise) {
        return state.fetchPromise
      }
      const url = `/startups/${startupId}/applications/${applicationId}`
      const fetchPromise = http.getAuthed(url)
      commit('START_FETCH', fetchPromise)
      try {
        const response = await fetchPromise
        commit('SET_APPLICATION_DATA', response.data)
        return fetchPromise
      } finally {
        commit('STOP_FETCH')
      }
    },

    async clearAnswer(
      { commit, state },
      { startupId, applicationId, data, delay = 0 },
    ) {
      return await saveApplication(
        { commit, state },
        {
          startupId,
          applicationId,
          data,
          delay,
          command: 'clear-answer',
          mutation: 'SAVE',
        },
      )
    },

    async saveAnswer(
      { commit, state },
      { startupId, applicationId, data, delay = 0 },
    ) {
      return await saveApplication(
        { commit, state },
        {
          startupId,
          applicationId,
          data,
          delay,
          command: 'save-answer',
          mutation: 'SAVE',
        },
      )
    },

    async save(
      { commit, state },
      { startupId, applicationId, data, delay = 0 },
    ) {
      return await saveApplication(
        { commit, state },
        {
          startupId,
          applicationId,
          data,
          delay,
          command: 'save',
          mutation: 'SAVE',
        },
      )
    },

    async submit(
      { commit, state },
      { startupId, applicationId, data, delay = 0 },
    ) {
      return await saveApplication(
        { commit, state },
        {
          startupId,
          applicationId,
          data,
          delay,
          command: 'submit',
          mutation: 'SUBMIT',
        },
      )
    },
  },
}

async function saveApplication(
  { commit, state },
  { startupId, applicationId, data, delay = 0, command, mutation },
) {
  const startMutation = `START_${mutation}`
  const stopMutation = `STOP_${mutation}`

  commit(startMutation)
  const url = `/startups/${startupId}/applications/${applicationId}/${command}`
  try {
    await delayed(http.postAuthed(url, data), delay)
    return state.application
  } finally {
    commit(stopMutation)
  }
}
